import React from 'react';
import cx from 'classnames';
import { handleCookieConsent, onUsePrivacyManagerHandler } from 'lib/cookie-consent';

type Props = {
    header?: React.ReactNode;
    content?: React.ReactNode;
    sidebar?: React.ReactNode;
    footer?: React.ReactNode;
    progress?: React.ReactNode;
    mobilePanel?: React.ReactNode;
    modal?: React.ReactNode;
    cta?: React.ReactNode;
    cookieNotification?: React.ReactNode;
    // theme?: Theme;
    extraClass?: string;
    jsClass?: string;
    contentCenter?: boolean;
    headerCenter?: boolean;
    backgroundColor?: string;
    isFlexible?: boolean;
    contentBackgroundColor?: string;
};

function Page(props: Props) {
    const {
        header,
        content,
        sidebar,
        footer,
        progress,
        mobilePanel,
        modal,
        cta,
        cookieNotification,
        // theme = Theme.DATE,
        extraClass,
        jsClass = 'js-mobile-panel-parent',
        contentCenter,
        headerCenter,
        backgroundColor,
        isFlexible,
        contentBackgroundColor,
    } = props;

    const className = {
        block: cx({
            page: true,
            // [mapThemeToClassNames[theme]]: true,
            [extraClass as string]: extraClass,
            [jsClass]: jsClass,
            'has-sidebar': sidebar,
        }),
        inner: cx({
            page__inner: true,
            'page__inner--with-sidebar': sidebar,
        }),
        header: cx({
            page__header: true,
            'page__header--center': headerCenter,
        }),
        sidebar: 'page__sidebar',
        content: cx({
            page__content: true,
            'page__content--flexible': isFlexible,
            'page__content--align-center': contentCenter,
        }),
    };

    React.useEffect(() => {
        if (process.env.NODE_ENV === 'production') {
            const listenerId = __tcfapi?.('addEventListener', 2, handleCookieConsent);

            return () => {
                if (listenerId) {
                    __tcfapi?.('removeEentListener', 2, null, listenerId);
                }
            };
        } else {
            return;
        }
    }, []);

    React.useEffect(() => {
        onUsePrivacyManagerHandler();
    }, []);

    const pageContent = (
        <>
            {sidebar ? <div className={className.sidebar}>{sidebar}</div> : null}
            {content ? (
                <div
                    className={className.content}
                    style={{ ['backgroundColor' as string]: contentBackgroundColor }}
                >
                    {content}
                </div>
            ) : null}

            {progress ? <div className="page__progress">{progress}</div> : null}

            {mobilePanel ? <div className="page__mobile-panel">{mobilePanel}</div> : null}

            {modal ? <div className="page__modal">{modal}</div> : null}

            {cta ? (
                <div className="page__modal-content" style={{ display: 'none' }} area-hidden="true">
                    <div data-modal-container="js-form-download-app">{cta}</div>
                </div>
            ) : null}

            {cookieNotification ? (
                <section className="page__cookie-notification">{cookieNotification}</section>
            ) : null}
        </>
    );

    return (
        <div className={className.block} style={{ backgroundColor }}>
            {header ? <header className={className.header}>{header}</header> : null}

            <main className={className.inner}>{pageContent}</main>

            {footer ? <footer className="page__footer">{footer}</footer> : null}
        </div>
    );
}

// Page.Theme = Theme;

export default Page;
